//   发现好货
export default [{
  path: '/brandSpike',
  name: 'brandSpike',
  meta: {
    index: 2
  },
  component: () => import('@/views/brandSpike/index')
}]
